import React, { useContext } from "react";

import PersonIcon from "@mui/icons-material/Person";

import "./User.css";
import DashboardContext from "../../context/DashboardContext";
import { useAuth } from "../../hooks/useAuth";

const User = ({ ...props }) => {
  const { setIsLoginVisible, isSideBarExpanded } = useContext(DashboardContext);

  const { user } = useAuth();

  const handleClick = () => {
    // setIsLoginVisible(true);
    // console.log("User Badge Clicked")
  }
  return (
    <div
      className="user-container"
      onClick={handleClick}
      {...props}
    >
      {/* HR css in App.css */}
      {isSideBarExpanded && <hr className="solid-grey" />}
      <div className="user-badge">
        <PersonIcon />
        {isSideBarExpanded && user && (
          <h2 className="user-name text-header">{user.userName}</h2>
        )}

        {isSideBarExpanded && !user && (
          <div className="user-login-button">Login</div>
        )}
      </div>
    </div>
  );
};

export default User;
